<template lang="">
    <div>
        
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="">
    
</style>


// WEBPACK FOOTER //
// informacionView.vue?677878ab